<template>
  <body>
    <!-- 한국어 -->
    <template v-if="isKorean">
      <h3 class="title">결제 및 환불 정책</h3>
      <div class="wrapper-paragraph">
        <p class="accent">시행일: 2025년 12월 01일</p>
        <p>
          본 정책은 SconAI(이하 "회사")가 제공하는 SconChat 서비스(이하 "서비스")의
          유료 구독 서비스 이용과 관련하여, 결제 및 환불에 관한 사항을 규정함을
          목적으로 합니다.
        </p>
      </div>

      <!-- 제1조 -->
      <h4 class="accent section-title">제1조 (서비스 이용 요금)</h4>
      <div class="wrapper-paragraph">
        <p>회사가 제공하는 서비스는 유료 구독 방식으로 제공됩니다.</p>
        <p>
          서비스 이용 요금은 회사가 정한 요금제에 따라 부과되며, 각 요금제의 세부
          내용은 웹사이트에서 확인할 수 있습니다.
        </p>
        <p>
          이용자는 회사가 정한 결제 수단을 통해 서비스 이용 요금을 납부해야
          합니다.
        </p>
      </div>

      <!-- 제2조 -->
      <h4 class="accent section-title">제2조 (결제 방식 및 자동 결제)</h4>
      <div class="wrapper-paragraph">
        <p>
          이용자는 추가 결제와 관련된 세부 설정(자동결제 사용 여부, 충전 시점, 1회
          충전 금액, 추가 결제 한도 금액)을 미리 지정할 수 있습니다.
        </p>
        <p>
          회사는 이용자가 선택한 요금제에 포함된 서비스 사용량(예: 통역 시간,
          크레딧 등)을 초과하여 서비스를 이용할 경우, 사전에 이용자가 동의하고
          지정한 설정에 따라 추가 요금을 자동 결제할 수 있습니다.
        </p>
        <p>
          추가 결제를 비활성화했거나, 이용자 또는 회사가 설정한 사용량 한도를
          초과한 경우에는 서비스 이용이 제한될 수 있습니다.
        </p>
      </div>

      <!-- 제3조 -->
      <h4 class="accent section-title">제3조 (추가 결제 정책)</h4>
      <div class="wrapper-paragraph">
        <p>
          회사는 이용자가 선택한 요금제에 포함된 서비스 사용량(예: 통역 시간,
          크레딧 등)을 초과하여 서비스를 이용할 경우, 해당 초과분에 대해 추가
          요금을 부과할 수 있습니다.
        </p>
        <p>
          추가 요금은 이용자가 선택한 요금제 또는 추가 사용량에 대한 별도 상품에
          따라 자동으로 결제됩니다. 추가 결제 방식 및 요율은 웹사이트 또는 앱
          내에서 안내됩니다.
        </p>
        <p>
          이용자는 추가 결제에 대한 세부 내용을 사전에 확인하고 동의해야 합니다.
        </p>
      </div>

      <!-- 제4조 -->
      <h4 class="accent section-title">제4조 (환불 정책)</h4>

      <div class="wrapper-paragraph">
        <p>
          1. 일반 원칙: 회사는 「콘텐츠산업진흥법」, 「전자상거래 등에서의 소비자보호에 관한
          법률」 등 관련 법령을 준수하여 이용자의 환불 요청을 처리합니다.
        </p>
      </div>

      <div class="wrapper-paragraph">
        <p>2. 구독 해지 및 환불:</p>

        <div class="wrapper-paragraph small">
          <p class="accent">가) 구독 해지</p>
          <p>
            이용자가 서비스 구독을 해지하는 경우, 다음 결제일부터 요금이
            청구되지 않습니다.
          </p>
          <p>현재 결제된 기간에 대한 서비스는 계속 이용할 수 있습니다.</p>
        </div>

        <div class="wrapper-paragraph small">
          <p class="accent">나) 환불 정책</p>

          <p class="accent">· 전액 환불</p>
          <p>
            결제일로부터 7일 이내에 서비스를 개시하지 않은 상태에서 해지를
            요청한 경우 전액 환불합니다.
          </p>
          <p>
            서비스의 중대한 결함으로 인해 정상적인 이용이 불가능한 경우
          </p>
          <p>기타 법령에 따라 환불이 의무화된 경우</p>

          <p class="accent">· 부분 환불</p>
          <p>
            서비스를 개시하였거나, 결제일로부터 7일이 지났다면 아래 기준에
            따라 환불됩니다.
          </p>
          <p>
            사용 후 남은 크레딧과 사용 기간을 일할 계산한 크레딧 중 더 작은
            금액을 기준으로 환불합니다.
          </p>
          <p>할인된 금액은 환불 대상에서 제외됩니다.</p>
          <p>
            이용자의 단순 변심으로 인한 환불 시 결제 수수료를 제외한 금액이
            환불됩니다.
          </p>
        </div>
      </div>

      <div class="wrapper-paragraph">
        <p>3. 환불 절차:</p>

        <div class="wrapper-paragraph">
          <p>
            가) 환불을 요청하려는 이용자는 고객센터를 통해 환불 사유와 결제 정보를
            회사에 제출해야 합니다.
          </p>
          <p>
            나) 회사는 환불 요청을 접수한 날로부터 3영업일 이내에 환불 가능 여부를
            심사하고, 환불이 결정된 경우 3영업일 이내에 처리합니다.
          </p>
          <p>
            다) 결제 수단에 따라 수수료가 발생할 수 있으며, 이는 이용자가
            부담합니다.
          </p>
          <p>
            라) 환불 금액은 남은 크레딧을 환산한 금액에서 할인 금액 등을 제외하여
            산정합니다.
          </p>
        </div>
      </div>

      <div class="wrapper-paragraph">
        <p>4. 추가 결제에 대한 환불:</p>
        <div class="wrapper-paragraph">
          <p>
            추가 결제 금액에 대한 환불은 해당 추가 결제가 발생한 원인 및 이용 내역을
            기준으로 본 조의 환불 기준에 따라 처리합니다.
          </p>
        </div>
      </div>

      <!-- 제5조 -->
      <h4 class="accent section-title">제5조 (과오납금의 환불)</h4>

      <div class="wrapper-paragraph">
        <p>
          회사의 고의 또는 과실로 인해 이용자에게 과오납금이 발생한 경우, 회사는
          과오납된 금액을 전액 환불합니다.
        </p>
        <p>
          이용자의 귀책사유로 과오납금이 발생한 경우, 회사는 환불 과정에서
          발생하는 비용(수수료 등)을 공제한 후 환불할 수 있습니다.
        </p>
      </div>

      <!-- 제6조 -->
      <h4 class="accent section-title">제6조 (정책의 변경)</h4>
      <div class="wrapper-paragraph">
        <p>
          회사는 본 결제 및 환불 정책을 변경할 수 있으며, 변경 시에는 시행일 7일
          전부터 서비스 웹사이트에 공지합니다.
        </p>
        <p>
          다만, 이용자에게 불리한 중대한 변경이 발생할 경우 최소 30일 전에
          공지합니다.
        </p>
        <p>
          본 결제 및 환불 정책의 시행일은 2025년 12월 01일입니다.
        </p>
      </div>
    </template>

    <!-- English (default) -->
    <template v-else>
      <h3 class="title">Payment and Refund Policy</h3>
      <div class="wrapper-paragraph">
        <p class="accent">Effective Date: December 1, 2025</p>
        <p>
          This Payment and Refund Policy ("Policy") sets forth the terms and conditions governing payments and refunds
          in connection with your use of the paid subscription services offered by SconAI Inc. ("Company") through the
          SconChat platform ("Services").
        </p>
      </div>

      <!-- Section 1 -->
      <h4 class="accent section-title">Section 1. Service Fees</h4>
      <div class="wrapper-paragraph">
        <p>The Services are offered on a paid subscription basis.</p>
        <p>
          Service fees are determined by the subscription plan you select. Detailed pricing information for each
          available plan is published on our website.
        </p>
        <p>
          You are required to pay all applicable service fees using a payment method accepted by the Company.
        </p>
      </div>

      <!-- Section 2 -->
      <h4 class="accent section-title">Section 2. Payment Methods and Automatic Billing</h4>
      <div class="wrapper-paragraph">
        <p>
          You may configure your additional billing preferences in advance, including whether to enable automatic
          top-ups, when top-ups are triggered, the amount charged per top-up, and the maximum limit for additional
          charges.
        </p>
        <p>
          If your usage exceeds the allowance included in your subscription plan (e.g., interpretation time or
          credits), the Company may automatically charge additional fees in accordance with the settings you have
          pre-authorized.
        </p>
        <p>
          If additional billing has been disabled, or if your usage reaches the limit set by you or the Company,
          access to the affected Services may be temporarily restricted.
        </p>
      </div>

      <!-- Section 3 -->
      <h4 class="accent section-title">Section 3. Overage Charges</h4>
      <div class="wrapper-paragraph">
        <p>
          If your usage of the Services exceeds the allowance included in your subscription plan (e.g., interpretation
          time or credits), the Company may charge additional fees for the excess usage.
        </p>
        <p>
          Such charges will be assessed automatically based on your subscription plan or the applicable overage
          pricing. Details regarding overage rates and billing methods are available on our website and within the
          application.
        </p>
        <p>
          You are responsible for reviewing and accepting the applicable overage terms prior to incurring such
          charges.
        </p>
      </div>

      <!-- Section 4 -->
      <h4 class="accent section-title">Section 4. Refund Policy</h4>

      <div class="wrapper-paragraph">
        <p>
          1. General Principles: The Company processes all refund requests in compliance with applicable laws and
          regulations, including consumer protection statutes governing electronic commerce and digital content
          services.
        </p>
      </div>

      <div class="wrapper-paragraph">
        <p>2. Subscription Cancellation and Refunds:</p>

        <div class="wrapper-paragraph small">
          <p class="accent">(a) Cancellation</p>
          <p>
            If you cancel your subscription, no further charges will be applied from the next billing cycle onward.
          </p>
          <p>
            You will retain access to the Services for the remainder of the current billing period for which payment
            has already been made.
          </p>
        </div>

        <div class="wrapper-paragraph small">
          <p class="accent">(b) Refund Eligibility</p>

          <p class="accent">· Full Refund</p>
          <p>
            A full refund will be issued if you request cancellation within seven (7) days of the payment date and
            have not yet commenced use of the Services.
          </p>
          <p>
            A full refund will also be provided if the Services are rendered unusable due to a critical defect
            attributable to the Company.
          </p>
          <p>
            Any other circumstances in which a refund is mandated by applicable law will likewise entitle you to a
            full refund.
          </p>

          <p class="accent">· Partial Refund</p>
          <p>
            If you have already commenced use of the Services, or if more than seven (7) days have elapsed since the
            payment date, refunds will be calculated in accordance with the following criteria.
          </p>
          <p>
            The refund amount will be based on the lesser of (i) the value of unused credits remaining at the time
            of cancellation, or (ii) the pro-rated value of the unused portion of the subscription term.
          </p>
          <p>Any discounted amounts are excluded from the refund calculation.</p>
          <p>
            For cancellations arising solely from a change of mind, the refund will be processed after deducting any
            applicable payment processing fees.
          </p>
        </div>
      </div>

      <div class="wrapper-paragraph">
        <p>3. Refund Procedure:</p>

        <div class="wrapper-paragraph">
          <p>
            (a) To request a refund, you must submit your refund request—including the reason for the refund and
            relevant payment details—to our customer support team.
          </p>
          <p>
            (b) The Company will review your request within three (3) business days of receipt and, if approved,
            will process the refund within a further three (3) business days.
          </p>
          <p>
            (c) Depending on your payment method, transaction fees may apply and will be borne by you.
          </p>
          <p>
            (d) The refund amount will be calculated based on the value of your remaining credits, after deducting
            any applicable discounts or other adjustments.
          </p>
        </div>
      </div>

      <div class="wrapper-paragraph">
        <p>4. Refunds for Overage Charges:</p>
        <div class="wrapper-paragraph">
          <p>
            Refund requests relating to overage charges will be assessed based on the circumstances that gave rise
            to such charges and your actual usage history, and will be handled in accordance with the refund
            criteria set forth in this Section.
          </p>
        </div>
      </div>

      <!-- Section 5 -->
      <h4 class="accent section-title">Section 5. Erroneous or Duplicate Payments</h4>

      <div class="wrapper-paragraph">
        <p>
          If an overpayment or erroneous charge occurs as a result of the Company's intentional act or negligence,
          the Company will refund the full amount of such overpayment.
        </p>
        <p>
          If the overpayment is attributable to your own error, the Company may deduct any reasonable processing
          costs (including applicable transaction fees) before issuing the refund.
        </p>
      </div>

      <!-- Section 6 -->
      <h4 class="accent section-title">Section 6. Amendments to this Policy</h4>
      <div class="wrapper-paragraph">
        <p>
          The Company reserves the right to amend this Payment and Refund Policy at any time. Any changes will be
          announced on our website no later than seven (7) days prior to the effective date of the amendment.
        </p>
        <p>
          In the event of material changes that are adverse to users, notice will be provided at least thirty (30)
          days in advance.
        </p>
        <p>
          This Policy is effective as of December 1, 2025.
        </p>
      </div>
    </template>
  </body>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { locale } = useI18n();
const isKorean = computed(() => locale.value === 'ko');
</script>

<style lang="scss" scoped>
.title {
  font-weight: bold;
  margin-top: 1rem;
  margin-bottom: 1.5rem;
}

.section-title {
  margin: 1.5rem 0 0.5rem 0;
}

.wrapper-paragraph {
  margin: 0 0 1rem 1.5rem;

  .small {
    margin: 0 0 0 1.5rem;
  }
}
</style>
